
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class Step extends Vue {
  @Prop() stepData: any;

  // SAL 是显示超时还是显示距离时间
  isShowTimeLabel(val: { [key: string]: any }) {
    const SLATime = Number(this.stepData.SLATime); // 超时总时间（以分钟为单位）
    let isOverDay: number | string = 0; // 天数
    let isOverHour: number | string = 0; // 小时
    let isOverMin: number | string = 0; // 分钟
    let isOverTime: boolean = false; // 是否超时
    let moreThanday = false; // 是否大于一天
    if (this.stepData.SLAState && this.stepData.SLAState.indexOf('超时') > -1) {
      isOverTime = true;
      moreThanday = SLATime / 60 > 24; // 是否大于24小时
      if (moreThanday) {
        isOverDay = Math.floor(SLATime / 60 / 24);
      } else {
        isOverHour = (SLATime / 60).toFixed(2);
      }
    } else {
      isOverTime = false;
      isOverDay = Math.floor(SLATime / 60 / 24);
      isOverHour = Math.floor((SLATime - isOverDay * 24 * 60) / 60);
      isOverMin = SLATime - isOverDay * 60 * 24 - isOverHour * 60;
    }

    return {
      isOverTime,
      isOverDay,
      isOverHour,
      isOverMin,
      moreThanday
    };
  }

  // 获取SLA处理过程的时间信息
  getProcessInfo() {
    let processStep: any[] = [];
    if (this.stepData.SourceEnum === 1) {
      // 产品
      processStep = [
        {
          topTitle: '',
          topDesc: '',
          bottomTitle: '反馈时间（一线）',
          bottomDesc: this.setTime(this.stepData.CreatedTime),
          iconClass: this.getIconClass(
            this.stepData.CreatedTime,
            '',
            '反馈时限（一线）'
          )
        },
        {
          topTitle: '任务下达时限',
          topDesc: this.setTime(this.stepData.GiveTaskLimitTime),
          bottomTitle: '任务下达时间',
          bottomDesc: this.setTime(this.stepData.GiveTaskTime),
          iconClass: this.getIconClass(
            this.stepData.GiveTaskTime,
            this.stepData.GiveTaskLimitTime,
            '任务下达时限'
          )
        },
        {
          topTitle: '产品回复时限',
          topDesc: this.setTime(this.stepData.ProductReplyLimitTime),
          bottomTitle: '产品回复时间',
          bottomDesc: this.setTime(this.stepData.ProductReplyTime),
          iconClass: this.getIconClass(
            this.stepData.ProductReplyTime,
            this.stepData.ProductReplyLimitTime,
            '产品回复时限'
          )
        },
        {
          topTitle: '关闭时限',
          topDesc: this.setTime(this.stepData.CloseLimitTime),
          bottomTitle: '关闭时间',
          bottomDesc: this.setTime(this.stepData.CloseTime),
          iconClass: this.getIconClass(
            this.stepData.CloseTime,
            this.stepData.CloseLimitTime,
            '关闭时限'
          )
        }
      ];
    } else if (this.stepData.SourceEnum === 2) {
      // 项目
      processStep = [
        {
          topTitle: '',
          topDesc: '',
          bottomTitle: '反馈时间（一线）',
          bottomDesc: this.setTime(this.stepData.CreatedTime),
          iconClass: this.getIconClass(
            this.stepData.CreatedTime,
            '',
            '反馈时限（一线）'
          )
        },
        {
          topTitle: '需求完成时限',
          topDesc: this.setTime(this.stepData.TaskLimitTime),
          bottomTitle: '需求完成时间',
          bottomDesc: this.setTime(this.stepData.CloseTime),
          iconClass: this.getIconClass(
            this.stepData.CloseTime,
            this.stepData.TaskLimitTime,
            '需求完成时限'
          )
        }
      ];
    }

    return processStep;
  }

  setTime(time: string) {
    return time ? moment(time).format('YYYY-MM-DD HH:mm') : '';
  }

  getIconClass(time: string, limit: string, isOverTimeKey: string) {
    let iconClass: string = 'dian-grey';
    if (time) iconClass = 'dian-blur';
    if (
      new Date(time).getTime() > new Date(limit).getTime() ||
      (this.stepData.SLAState && this.stepData.SLAState.indexOf('超时') > -1 &&
        this.stepData.SLANodeName === isOverTimeKey)
    ) {
      iconClass = 'waring el-icon-warning';
    }

    return iconClass;
  }
}
